import { ConditionParser } from "./ConditionParser";
import { FalseNode, TrueNode } from "./ExpressionNodes";
/**
 * A Condition is a binary tree of expression nodes that are evaluated recursively
 */
export class Condition {
    constructor(condition) {
        // An empty condition is true
        if (typeof condition === "boolean") {
            this.rootExpression = (condition) ? new TrueNode(0, String(condition).length) : new FalseNode(0, String(condition).length);
            this.conditionText = String(condition);
            return;
        }
        this.conditionText = condition;
        const parserResult = ConditionParser.parse(condition);
        if (!parserResult.status) {
            console.error(`[training] Error while parsing condition "${condition}"`);
            this.rootExpression = new FalseNode(0, condition.length);
        }
        else {
            this.rootExpression = parserResult.value;
        }
    }
    evaluate(context) {
        return this.rootExpression.evaluate(context);
    }
    evaluateWithTrace(context) {
        return this.rootExpression.evaluateWithTrace(context);
    }
}
